import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  exitStaffAsync,
  fetchReasonForExitListAsync,
  fetchStaffListAsync,
} from "../thunks/staffListThunk";
import { STATUS, UserData } from "./userDetailslice";

// Define types for the response data structure
export interface ResponseData {
  data: UserData[];
  page: number;
  size: number;
  totalCount: number;
}

export interface StaffListData {
  staffList: ResponseData | null;
  loading: boolean;
  error: string | null;
  key: string | null;
}
const staffListState: StaffListData & ExitReasonsState = {
  staffList: null,
  loading: false,
  error: null,
  exitReasonObj: null,
  exitStaffStatus: STATUS.IDLE,
  exitStaffErrorMessage: null,
  key: null,
};

export interface ExitReason {
  reason: string;
  requiresComments: boolean;
}
export interface ExitReasonObj {
  exitReasons: ExitReason[];
}
export interface ExitReasonsState {
  exitReasonObj: ExitReasonObj | null;
  exitStaffStatus: string | null;
  exitStaffErrorMessage: string | null;
}
const staffList = createSlice({
  name: "Staff/Staff-list",
  initialState: staffListState,
  reducers: {
    resetExitStaffStatus: (state) => {
      state.exitStaffStatus = STATUS.IDLE;
    },
    setKey: (state, action: PayloadAction<string | null>) => {
      state.key = action.payload; // Set the key in the state
    },
    resetKey: (state) => {
      state.key = null; 
    },
    resetStaffList: (state) => {
      state.staffList = null; // Reset the staff list to null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffListAsync.pending, (state) => {
        state.staffList=null;
        state.loading = true; // Set loading to true when fetching starts
        state.error = null; // Reset error state
      })
      .addCase(fetchStaffListAsync.fulfilled, (state, action) => {
        state.staffList=null;
        state.staffList = action.payload;
        state.loading = false; // Set loading to false when fetching is successful
      })
      .addCase(fetchStaffListAsync.rejected, (state, action) => {
        state.loading = false; // Set loading to false when fetching fails
        state.error = action.error.message ?? null; // Update error state
      })
      .addCase(fetchReasonForExitListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReasonForExitListAsync.fulfilled, (state, action) => {
        state.exitReasonObj = action.payload;
        state.loading = false;
      })
      .addCase(fetchReasonForExitListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? null;
      })
      .addCase(exitStaffAsync.pending, (state) => {
        state.exitStaffStatus = STATUS.LOADING;
        state.exitStaffErrorMessage = null;
      })
      .addCase(
        exitStaffAsync.fulfilled,

        (state, action) => {
          state.exitStaffStatus = STATUS.SUCCESS;
          state.exitStaffErrorMessage = null;
        }
      )
      .addCase(exitStaffAsync.rejected, (state, action) => {
        state.exitStaffStatus = STATUS.FAILED;
        state.exitStaffErrorMessage = action.error.message ?? null;
      });
  },
});
export const { resetExitStaffStatus,setKey ,resetKey,resetStaffList} = staffList.actions;
export default staffList.reducer;
